import en from '../lang/en';
import ta from '../lang/ta';

const languages = { en, ta };

export default function getLang(lang, key) {
  return languages[lang][key];
}
